import { render } from "./ProceedingModal.vue?vue&type=template&id=e46adb4c&scoped=true"
import script from "./ProceedingModal.vue?vue&type=script&lang=js"
export * from "./ProceedingModal.vue?vue&type=script&lang=js"

import "./ProceedingModal.vue?vue&type=style&index=0&id=e46adb4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e46adb4c"]])

export default __exports__